import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND, FOOTER_LINKS, CTA_LINKS } from "@/data/content";
import { goTo } from "./primitives";

export default function Footer() {
  return (
    <footer className="border-t border-brand-navy/10 bg-white">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <img src={BRAND.logo} alt="Transferência Academy" className="h-11" />
              <div>
                <p className="font-display text-lg font-semibold tracking-tight text-brand-navy">
                  {BRAND.name}
                </p>
                <p className="mt-0.5 text-[10px] font-semibold uppercase tracking-[0.3em] text-brand-goldDark">
                  {BRAND.submark}
                </p>
              </div>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-brand-navy/55">
              {BRAND.tagline}
            </p>
          </div>

          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-navy/40">
              Navegação
            </p>
            <ul className="mt-4 space-y-2.5">
              {FOOTER_LINKS.map((l) => (
                <li key={l.label}>
                  <button
                    onClick={() => goTo(l.href)}
                    data-testid={`footer-link-${l.label}`}
                    className="text-sm text-brand-navy/60 transition-colors hover:text-brand-navy"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-navy/40">
              Redes
            </p>
            <a
              href={CTA_LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="mt-4 inline-flex items-center gap-2.5 rounded-full border border-brand-navy/12 px-4 py-2.5 text-sm text-brand-navy transition-colors hover:border-brand-gold/50 hover:text-brand-goldDark"
            >
              <Instagram className="h-4 w-4" />
              @transferencia_academy
            </a>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-brand-navy/8 pt-6 text-xs text-brand-navy/40 sm:flex-row">
          <p>© {new Date().getFullYear()} Transferência Academy. Todos os direitos reservados.</p>
          <Link
            to="/politica-de-privacidade"
            data-testid="footer-privacy"
            className="font-medium text-brand-navy/55 transition-colors hover:text-brand-navy"
          >
            Política de Privacidade
          </Link>
        </div>
      </div>
    </footer>
  );
}
